import React from 'react'

const SlicknextCircle = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 82 82"
            height={80}
            width={80}
            {...props}
        >
            <path
                stroke="#080807"
                strokeMiterlimit="10"
                d="M20.289 40.577h40.577m0 0c-7.471 0-13.526 6.055-13.526 13.526m13.526-13.526c-7.471 0-13.526-6.054-13.526-13.525"
            />
            <circle cx="41" cy="41" r="40.5" stroke="#080807" />
        </svg>
    )
}

export default SlicknextCircle
